console.log('✅ home-page-featured-products.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import { getLinksTranslationByKey } from '../../js/router-routes-manager.js';
import { saveToLocalStorage, loadFromLocalStorage } from '../../js/utils-local-storage.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { buildComponentCategoryCard } from '../cards/category-card.js';
import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';

import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

let _tempTextTranslator = null;
export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

let _tempLinksTranslator = null;
export async function initTempLinksTranslator(lang) {
  _tempLinksTranslator = await initLinksTranslator(lang);
}

//const lang = appState.SiteLanguageCookie;

export async function buildComponentHomePageFeaturedProducts() {
  console.log(
    `🔄 Building Component: HomePageFeaturedProducts - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    await initTempTextTranslator(appState.SiteLanguageCookie);
    await initTempLinksTranslator(appState.SiteLanguageCookie);
    // const tempTranslator = await loadTextTranslations(lang);

    // Destructure just the keys you need, giving them your desired local names
    const {
      keyExploreManufacturersByProductType: lblExploreManufacturersByProductType,
      keySeeAllProductTypes: lblSeeAllProductTypes,
    } = _tempTextTranslator;

    const { keyProducts: linkProducts } = _tempLinksTranslator;

    // Fetch featured products

    const featuredProductsHtml = await renderFeaturedProductsHtmlStatic();

    // Build the featured products HTML
    const html = `
            <center>
                <h2>${lblExploreManufacturersByProductType}</h2>
                <br />
                <div id="featuredHomePageProductsContainerDiv" class="FeaturedHomePageCategoryContainer">
                    ${featuredProductsHtml}
                </div>
                <br /><br />
                <a href="${linkProducts}">${lblSeeAllProductTypes}</a>
                <br />
            </center>
        `;

    console.log('✅ HomePageFeaturedProducts built successfully.');

    // Register event listeners
    // registerEventListenerToAttach(attachEventListenersHomePageFeaturedProducts);

    registerEventListenerToAttach(async () => attachEventListenersHomePageFeaturedProducts());

    return html;
  } catch (err) {
    console.error('❌ Error building HomePageFeaturedProducts:', err);
    return '<div>Error loading featured products</div>';
  }
}

async function renderFeaturedProductsHtml() {
  console.log('🔄 Rendering featured products HTML');

  const products = await populateHomePageFeaturedProducts();

  if (!products || products.length === 0) {
    return `<p>No featured products available at the moment.</p>`;
  }

  const productCards = await Promise.all(
    products.map(async product => {
      const builtLink = `/${appState.SiteLanguageCookie}/${product.defaultProductDepartmentID}/${product.defaultDepartmentSEOPageName}/${product.defaultProductCategoryID}/${product.defaultCategorySEOPageName}/${product.productID}/${product.seoPageName}`;

      // Determine the image source
      const imageSource = product.image1FileName;

      const name = product.name;
      const categoryCardType = 'Basic';

      return await buildComponentCategoryCard(builtLink, imageSource, name, categoryCardType);
    })
  );

  return productCards.join('');
}

/**
 * Attach event listeners to the HomePageFeaturedProducts component
 */
async function attachEventListenersHomePageFeaturedProducts() {
  try {
    console.log('✅ HomePageFeaturedProducts event listeners attached.');

    const featuredHomePageProductsContainerDiv = document.getElementById(
      'featuredHomePageProductsContainerDiv'
    );
    if (!featuredHomePageProductsContainerDiv) {
      console.error("❌ Element with ID 'featuredHomePageProductsContainerDiv' not found.");
      return;
    } else {
      let html = await renderFeaturedProductsHtml();
      featuredHomePageProductsContainerDiv.innerHTML = html;
    }
  } catch (error) {
    console.error('❌ Error attaching event listeners to HomePageFeaturedProducts:', error);
  }
}

async function renderFeaturedProductsHtmlStatic() {
  if (isNodeEnvironment()) {
    return await renderFeaturedProductsHtml();
  } else {
    return await renderLoadingData();
  }
}

async function renderLoadingData() {
  const countOfItems = 18; // Replace this with your actual value

  const resultCardPromises = [];

  for (let i = 0; i < countOfItems; i++) {
    const name = '';
    const builtLink = '';
    const imageSource = '';
    const categoryCardType = 'Lazy';

    resultCardPromises.push(
      buildComponentCategoryCard(builtLink, imageSource, name, categoryCardType)
    );
  }

  const resultCards = await Promise.all(resultCardPromises);

  return resultCards.join('');
}

async function populateHomePageFeaturedProducts() {
  console.log(`✅ Populating Home Page Featured Products  - lang: ${appState.SiteLanguageCookie}`);

  const storageKey = `homePageFeaturedProducts_${appState.SiteLanguageCookie}`;

  // Try to load from localStorage first
  const cachedProducts = loadFromLocalStorage(storageKey);
  if (cachedProducts && Array.isArray(cachedProducts) && cachedProducts.length > 0) {
    console.log('✅ Loaded HomePageFeaturedProducts from cache');
    return cachedProducts;
  }

  // Fetch from the server if not cached
  console.log('🌐 Fetching HomePageFeaturedProducts from server');
  return await fetchHomePageFeaturedProducts();
}

async function fetchHomePageFeaturedProducts() {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Fetching featured products from pre-built data');
      const data = await myFetchJsonContentFromBuildData('home-page-featured-products.json');

      if (data && data[appState.SiteLanguageCookie]) {
        const products = data[appState.SiteLanguageCookie];
        console.log(
          `✅ Loaded featured products for language '${appState.SiteLanguageCookie}' from pre-built data`
        );
        return products;
      } else {
        console.warn(`⚠️ No featured products found for language '${appState.SiteLanguageCookie}'`);
        return [];
      }
    } else {
      const storageKey = `homePageFeaturedProducts_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000;

      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);

      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log('✅ Loaded featured products from cache');
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetAllHomePageFeaturedProductsAsync?languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to fetch featured products from server');

      const featuredProducts = await response.json();

      // Save to localStorage
      saveToLocalStorage(storageKey, featuredProducts);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log('🌐 Fetched featured products from the server');
      return featuredProducts;
    }
  } catch (error) {
    console.error('❌ Error fetching featured products:', error);
    return [];
  }
}
